import { NgModule } from 'angular-ts-decorators';

import { moduleName } from '../constants';

import { HeroCustomizerV3AwardComponent } from './award/hero-customizer-v3-award.component';
import { HeroCustomizerV3ImageGalleryComponent } from './hero-customizer-v3-image-gallery.component';
import { HeroCustomizerV3ImageSliderComponent } from './hero-customizer-v3-image-slider.component';

import { OpenHeroCustomizerV3ImageGalleryDirective } from './open-hero-customizer-v3-image-gallery.directive';

@NgModule({
  declarations: [
    HeroCustomizerV3ImageGalleryComponent,
    HeroCustomizerV3ImageSliderComponent,
    HeroCustomizerV3AwardComponent,

    OpenHeroCustomizerV3ImageGalleryDirective,
  ],
  id: `${moduleName}.image-gallery`,
  providers: [],
})
export class HeroCustomizerV3ImageGalleryModule {
}
